import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';

// Google Fonts - Inter
const link = document.createElement('link');
link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap';
link.rel = 'stylesheet';
document.head.appendChild(link);

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // 2 minutes (reduced from 5)
      gcTime: 1000 * 60 * 5, // 5 minutes (reduced from 10)
      retry: 1, // Retry only once (reduced from 3)
      retryDelay: 1000, // Fixed 1 second delay
      refetchOnWindowFocus: false, // Disable to reduce unnecessary requests
      refetchOnReconnect: true,
      refetchOnMount: true,
      // Network error handling
      networkMode: 'online',
    },
    mutations: {
      retry: 1, // Retry only once (reduced from 2)
      retryDelay: 1000,
      networkMode: 'online',
    },
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Service Worker DISABLED for debugging
// Cache sorununa yol açtığı için devre dışı bırakıyoruz.
// Force unregister ANY service worker to fix caching issues
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}
